import { API, standardResponse } from "./middleware";

export async function searchStickers(dataSearch) {
  return API.post("api/sticker/search", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function fetchStickerCreate(data) {
  return API.post("/api/sticker/create", data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchStickerUpdate(id, data) {
  return API.put(`/api/sticker/update/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchStickerToggleStatus(id) {
  return API.put(`/api/sticker/changeStatus/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchStickerDelete(id) {
  return API.delete(`/api/sticker/delete/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}
